import { render, staticRenderFns } from "./AirticketorderdetailstwoRight.vue?vue&type=template&id=11a1ed99&scoped=true"
import script from "./AirticketorderdetailstwoRight.vue?vue&type=script&lang=js"
export * from "./AirticketorderdetailstwoRight.vue?vue&type=script&lang=js"
import style0 from "./AirticketorderdetailstwoRight.vue?vue&type=style&index=0&id=11a1ed99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a1ed99",
  null
  
)

export default component.exports